const overlays = new Set()

let overlayStateActive = false
let suppressNextPopstate = false

function handlePopstate() {
  if (suppressNextPopstate) {
    suppressNextPopstate = false
    return
  }

  if (!overlayStateActive || overlays.size === 0) {
    return
  }

  overlayStateActive = false
  const snapshot = Array.from(overlays)

  snapshot.forEach((controller) => {
    if (typeof controller.closeFromOverlayManager === "function") {
      controller.closeFromOverlayManager()
    }
  })
}

function cleanup() {
  if (overlays.size > 0) {
    const snapshot = Array.from(overlays)
    overlayStateActive = false

    snapshot.forEach((controller) => {
      if (typeof controller.closeFromOverlayManager === "function") {
        controller.closeFromOverlayManager()
      }
    })
  }

  overlays.clear()
  overlayStateActive = false
  suppressNextPopstate = false
}

if (typeof window !== "undefined") {
  window.addEventListener("popstate", handlePopstate)
  window.addEventListener("turbo:before-visit", cleanup)
  window.addEventListener("turbo:before-cache", cleanup)
}

export default {
  register(controller) {
    if (overlays.has(controller)) {
      return
    }

    overlays.add(controller)

    if (!overlayStateActive) {
      overlayStateActive = true
      history.pushState({ overlay: true }, "", window.location.href)
    }
  },

  unregister(controller, { fromPopstate } = { fromPopstate: false }) {
    overlays.delete(controller)

    if (overlays.size === 0 && overlayStateActive) {
      overlayStateActive = false

      if (!fromPopstate) {
        suppressNextPopstate = true
        history.back()
      }
    }
  }
}
